import { render } from "./EditUpgle.vue?vue&type=template&id=4eaeaf29&scoped=true"
import script from "./EditUpgle.vue?vue&type=script&lang=js"
export * from "./EditUpgle.vue?vue&type=script&lang=js"

import "./EditUpgle.vue?vue&type=style&index=0&id=4eaeaf29&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eaeaf29"]])

export default __exports__